import { BooksStatusChangeModal } from "components/BooksCrm/BooksStatusChangeModal";
import { UpdateTaskPrice } from "components/fileTax/updateTaskPrice";
import { Task } from "types/Models/task";
import { BooksTaskStatus } from "./useBooksTaskStatus";

export const BooksTaskStatusModals = ({
  task,
  status,
  isVariablePricing,
}: {
  task: Task;
  status: BooksTaskStatus;
  isVariablePricing: boolean;
}) => (
  <>
    <BooksStatusChangeModal statusUpdate={status.statusUpdate} />
    {status.isCompletePending && status.completedStateId && (
      <UpdateTaskPrice
        show
        closeModal={status.closeComplete}
        setShow={status.closeComplete}
        newStateId={status.completedStateId}
        groupId={task.group_uuid}
        taskId={task.uuid}
        task={status.fullTask ?? task}
        isVariablePricing={isVariablePricing}
        entityId={task.entity?.uuid}
      />
    )}
  </>
);
